import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	ariaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ariaLabel: {
		id: 'minimizable-modal.modal-container.minimized.messaged.aria-label',
		defaultMessage: 'Minimized modal',
		description: 'Aria label for minimized modal',
	},
});
export default messages;
